import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable()
export class DocumentsService {
  constructor(private http: HttpClient) { }

  configService = inject(ConfigService);

  getDocumentBookmarks(base64String: string): Observable<string[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (base64String.indexOf(',') >= 0) {
      base64String = base64String.split(',')[1];
    }
    const url = this.configService.readConfig().baseUrlDocuments + '/extractbookmarks';
    return this.http.post<string[]>(url, '"' + base64String + '"', { headers });
  }
}
